module.exports = __webpack_public_path__ + "media/images/hubspot-16b9a85c32d2d91035f77a83974c5966.svg";